import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) { }

  getReports(postdata){
    // console.log('reports.service.getReports - payload:', postdata); // prueba:
    return this.http.post(`${environment.baseUrl}/reportes/getReportsPDF.php`, postdata);
  }

  getArchivo(nombre){
    return this.http.get(`${environment.baseUrl}/reportes/getArchivo.php?report=${nombre}`);
  }

    // Añadido 21/07/2025 - Para poder descargar el Excel de los reportes
  getDataReportExcel(postdata) {
  return this.http.post(`${environment.baseUrl}/reportes/getDataReportExcel.php`, postdata);
}

  getArchivoA(nombre){
    return this.http.post(`${environment.baseUrl}/reportes/getArchivoA.php`,nombre);
  }

  getAnexo(nombre){
    return this.http.post(`${environment.baseUrl}/reportes/getAnexo.php`,nombre);
  }

  getCarnet(nombre){
    return this.http.post(`${environment.baseUrl}/reportes/getCarnet.php`,nombre);
  }
}
